import { styled } from 'parkdepot-shared/theme'

const Container = styled('div', ({ $theme }) => ({
    borderRadius: '2.4rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '2.4rem'
}))

export default Container

export const HrefLink = styled('a', {
    cursor: 'pointer !important',
    all: 'unset',
    display: 'block !important',
    fontSize: '1.4rem !important'
})

export const MobileLink = styled('a', ({ $theme }) => ({
    cursor: 'pointer !important',
    all: 'unset',
    display: 'block !important',
    marginTop: '0.6rem !important',
    fontSize: '1.4rem !important'
}))

export const SectionContainer = styled('div', ({ $theme }) => ({
    [$theme.mediaQuery.large]: {
        gap: '2.4rem',
        justifyContent: 'center',
        alignItems: 'stretch'
    }
}))

export const SectionTitle = styled('h6', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    margin: '0.8rem 0',
    fontWeight: 600,
    color: '#222323'
}))
